const SignatureAuditButtonConstants = {
  SIGNATURE_AUDIT_HISTORY_GET_SUCCESS: 'SIGNATURE_AUDIT_HISTORY_GET_SUCCESS',
  SIGNATURE_AUDIT_HISTORY_GET_FROM_SHARE_KEY_SUCCESS: 'SIGNATURE_AUDIT_HISTORY_GET_FROM_SHARE_KEY_SUCCESS',
  SIGNATURE_AUDIT_HISTORY_GET_FAILURE: 'SIGNATURE_AUDIT_HISTORY_GET_FAILURE',
  SIGNATURE_AUDIT_HISTORY_GET_REQUEST: 'SIGNATURE_AUDIT_HISTORY_GET_REQUEST',
};


export const ACCESS_LEVEL_MAP = {
  'declined-done': 'Declined',
  'edit-done': 'Signed',
  'sign-done': 'Signed',
  'view-done': 'Signed',
};

export default SignatureAuditButtonConstants;



// WEBPACK FOOTER //
// ./src-react/SignatureAuditButton/SignatureAuditButtonConstants.jsx